/**
 * Bottom sheets for preferences flow (menu, fund list, learn more).
 *
 * Belongs here: sheet UI.
 * Does not belong here: navigation impl.
 */
import BottomSheetContent from '../../../../../../components/BottomSheetComponents/BottomSheetContent'
import RenderHTML from '../../../../../../components/ui-components/RenderHTML'
import type { Question } from '../../../shared/types/questionnaire.types'

const SECTORAL_THEMATIC_QUESTION_ID = 'SECTORAL_GROUP_MULTI_SELECT_CATEGORY_1_SECTORAL'

const CONCENTRATION_ICON = `<svg width="28" height="28" viewBox="0 0 27.5007 27.5002" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M26.6013 24.9702C26.6993 25.1514 26.7507 25.3542 26.7507 25.5602C26.7507 25.7662 26.6993 25.969 26.6013 26.1502C26.5091 26.3308 26.3689 26.4824 26.1959 26.5884C26.0229 26.6942 25.8241 26.7502 25.6213 26.7502H13.8813C13.6785 26.7502 13.4797 26.6942 13.3067 26.5884C13.1338 26.4824 12.9935 26.3308 12.9013 26.1502C12.8033 25.969 12.752 25.7662 12.752 25.5602C12.752 25.3542 12.8033 25.1514 12.9013 24.9702L18.8013 14.3303C18.8824 14.1316 19.0208 13.9615 19.1989 13.8418C19.377 13.7221 19.5867 13.6582 19.8013 13.6582C20.0159 13.6582 20.2257 13.7221 20.4037 13.8418C20.5819 13.9615 20.7203 14.1316 20.8013 14.3303L26.6013 24.9702Z" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.7598 20.75V18.75" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.7502 24.0005C19.612 24.0005 19.5 23.8885 19.5 23.7503C19.5 23.6121 19.612 23.5001 19.7502 23.5001" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.7498 24.0002C19.888 24.0002 20 23.8882 20 23.7502C20 23.612 19.888 23.5 19.7498 23.5" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.75 0.75V18.75" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M0.75 5.75V13.75" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.75 0.75V9.75" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.75 5.75V13.75" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

const CALENDAR_WARNING_ICON = `<svg width="28" height="28" viewBox="0 0 25.5 25.5" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.75 9.75V14.75" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.75 19.75C12.4739 19.75 12.25 19.5262 12.25 19.25C12.25 18.9738 12.4739 18.75 12.75 18.75" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.75 19.75C13.0261 19.75 13.25 19.5262 13.25 19.25C13.25 18.9738 13.0261 18.75 12.75 18.75" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.75 3.75C2.21956 3.75 1.71086 3.96072 1.33578 4.33578C0.96072 4.71086 0.75 5.21956 0.75 5.75V22.75C0.75 23.2804 0.96072 23.7892 1.33578 24.1642C1.71086 24.5392 2.21956 24.75 2.75 24.75H22.75C23.2804 24.75 23.7892 24.5392 24.1642 24.1642C24.5392 23.7892 24.75 23.2804 24.75 22.75V5.75C24.75 5.21956 24.5392 4.71086 24.1642 4.33578C23.7892 3.96072 23.2804 3.75 22.75 3.75H2.75Z" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.75 0.75V6.75" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.75 0.75V6.75" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

const TIMING_ICON = `<svg width="28" height="28" viewBox="0 0 24.2137 24.2137" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.7852 0.75H21.5709C22.0729 0.75 22.5544 0.949431 22.9093 1.3044C23.2642 1.65939 23.4637 2.14083 23.4637 2.64286V6.42857" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M0.75 6.42857V2.64286C0.75 2.14083 0.949432 1.65939 1.3044 1.3044C1.65939 0.949432 2.14083 0.75 2.64286 0.75H6.42857" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.7852 23.4637H21.5709C22.0729 23.4637 22.5544 23.2642 22.9093 22.9093C23.2642 22.5544 23.4637 22.0729 23.4637 21.5709V17.7852" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M0.75 17.7852V21.5709C0.75 22.0729 0.949431 22.5544 1.3044 22.9093C1.65939 23.2642 2.14083 23.4637 2.64286 23.4637H6.42857" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.1063 17.7849C15.2425 17.7849 17.7849 15.2425 17.7849 12.1063C17.7849 8.97013 15.2425 6.42773 12.1063 6.42773C8.97013 6.42773 6.42773 8.97013 6.42773 12.1063C6.42773 15.2425 8.97013 17.7849 12.1063 17.7849Z" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

const VOLATILITY_CHART_ICON = `<svg width="255" height="160" viewBox="0 0 255 160" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.5 0L0.5 160" stroke="#F0F4F7"/>
<path d="M51.5 0L51.5 160" stroke="#F0F4F7"/>
<path d="M102.5 0L102.5 160" stroke="#F0F4F7"/>
<path d="M153.5 0L153.5 160" stroke="#F0F4F7"/>
<path d="M204.5 0L204.5 160" stroke="#F0F4F7"/>
<path d="M255.5 0L255.5 160" stroke="#F0F4F7"/>
<path d="M0 150C22 150 28.5 41 51 41C73.5 41 81 145 102 145C123 145 129 83.5 153 83.5C177 83.5 177.5 145 204.5 145C231.5 145 239 74.5 255 74.5" stroke="#1470CC" stroke-width="2"/>
<path d="M0 50.9C22 50.9 28.5 23 51 23C73.5 23 81 50.9 102 50.9C123 50.9 129 30 153 30C177 30 177.5 126 204.5 126C231.5 126 239 47.6 255 47.6" stroke="#CC5C2D" stroke-width="2"/>
<circle cx="3" cy="150" r="2.5" fill="#1470CC" stroke="white"/>
<circle cx="252" cy="74.5" r="2.5" fill="#1470CC" stroke="white"/>
<circle cx="3" cy="50.9" r="2.5" fill="#CC5C2D" stroke="white"/>
<circle cx="252" cy="47.6" r="2.5" fill="#CC5C2D" stroke="white"/>
</svg>`

export function isSectoralThematicLearnMoreQuestion(question: Question | null | undefined): boolean {
  return (question?.id ?? '') === SECTORAL_THEMATIC_QUESTION_ID
}

export function SectoralThematicLearnMoreSheet({ onDismiss }: { onDismiss: () => void }) {
  return (
    <BottomSheetContent
      heading="Sectoral/Thematic Funds"
      onDismiss={onDismiss}
      bottomSheetHeadingClassName="!mb-0 !text-[22px] !font-[500] !leading-[160%] !text-[#232323]"
      bottomSheetBodyClassName="!pt-6"
    >
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-6 text-[14px] font-[400] leading-[140%] text-[#3D3D3D]">
          <p>Sectoral/thematic funds hold more than 80% in a very specific sector or investment theme.</p>
          <p>
            When that sector is booming, these funds do well. When it isn't, they can underperform, and may not bounce back for years.
          </p>
        </div>

        <p className="text-[22px] font-[500] leading-[130%] text-[#232323]">
          Why we don&apos;t recommend <br />
          them by default?
        </p>

        <SectoralThematicVolatilityChart />

        <SectoralThematicLearnMorePoint
          iconHtml={CONCENTRATION_ICON}
          title="Very high volatility"
          description="Since these funds depend on a focused sector instead of the broad market, their performance can be more unpredictable and volatile."
        />
        <SectoralThematicLearnMorePoint
          iconHtml={CALENDAR_WARNING_ICON}
          title="Less suited for long-term investing"
          description="Returns from these funds depend on when you enter and exit the market, and market cycles are hard to predict which makes them less suited for long term investing."
        />
        <SectoralThematicLearnMorePoint
          iconHtml={TIMING_ICON}
          title="Better as selective exposure"
          description="Hold them only if you understand the risks and have a strong reason to keep them."
        />

      </div>
    </BottomSheetContent>
  )
}

export function SectoralThematicVolatilityChart() {
  return (
    <div className="h-[192px] w-full overflow-hidden rounded-[12px] border border-[#F0F4F7]">
      <div className="flex h-[160px] w-full items-center justify-center px-4">
        <RenderHTML
          innerHTMLText={VOLATILITY_CHART_ICON}
          className="h-full w-full [&>svg]:block [&>svg]:h-full [&>svg]:w-full"
        />
      </div>
      <div className="flex justify-between px-5 text-[10px] font-[400] leading-[130%] text-[#D1D6D6]">
        <span>2021</span>
        <span>2022</span>
        <span>2023</span>
        <span>2024</span>
        <span>2025</span>
        <span>2026</span>
      </div>
    </div>
  )
}

export function SectoralThematicLearnMorePoint({
  iconHtml,
  title,
  description
}: {
  iconHtml: string
  title: string
  description: string
}) {
  return (
    <div className="flex items-start gap-3">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center">
        <RenderHTML
          innerHTMLText={iconHtml}
          className="h-7 w-7 [&>svg]:block [&>svg]:h-full [&>svg]:w-full"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-1 py-[3px]">
        <p className="text-[14px] font-[500] leading-[140%] text-[#232323]">{title}</p>
        <p className="text-[13px] font-[400] leading-[140%] text-[#6A6E6E]">{description}</p>
      </div>
    </div>
  )
}
